import { selector } from "recoil"

import { Quota, TeamQuota } from "../../interfaces"

import useCurrentService from "./currentService"
import useCurrentTeam from "./currentTeam"

// まだ何も読んでいない状態。上限 0 ではなく「未計測」なので、ここで
// totalQuota に 0 を置かない（無制限プランが上限 0 に見えてしまう）。
const initialQuota: Quota = {
  includedQuota: null,
  purchasedQuota: 0,
  totalQuota: null,
  usedQuota: 0,
  unlimited: false,
  measured: false,
  status: "active",
}

const initialState: TeamQuota = {
  membership: initialQuota,
  customDomain: initialQuota,
  buildTime: initialQuota,
  bandwidth: initialQuota,
  site: initialQuota,
}

export const useCurrentTeamQuotas = selector({
  key: "currentTeamQuotas",
  get({ get }) {
    const currentTeam = get(useCurrentTeam)
    if (currentTeam.id === "") return initialState

    const currentService = get(useCurrentService)

    const currentSubscription = currentTeam.subscriptions.find(
      (s) => s.serviceName === currentService.name,
    )

    if (!currentSubscription) {
      return initialState
    }

    return currentSubscription.teamQuotas
  },
})
